import { useState, useEffect } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { authenticated, isEnrolled, startEnrolled, UrlSave } from "./method";
import images from "../../assets/images.tsx";
import Swal from "sweetalert2";
import "../../assets/css/pin.css";

export default function Authenticate() {
    const location = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [data, setData] = useState(location.state?.data);

    const handleContinuar = async (e) => {
        e.preventDefault();
        setLoading(true);

        //const responseAuthenticated = await |(data.rut.padStart(15, '0'), data.password);
        //Descomentar en produccion
        //var dataResponse = responseAuthenticated.resultado.wmAutenticarResponse.wmAutenticarResult.diffgram.NewDataSet.DATA;        

        //if (dataResponse.HEADER === "AU00") {
        if (true) {
            let isEnroll = null;

            var response = await UrlSave(data);

            var responseIsEnrolled = await isEnrolled(data.rut, response.id);

            if (responseIsEnrolled.resultado.resultadoMensaje == "AU00") {
                var result = JSON.parse(responseIsEnrolled.resultado.respuesta);

                isEnroll = result.result.registro == "OK";
            }

            const responseStartEnrolled = await startEnrolled(data.rut, response.id);

            if (responseStartEnrolled.resultado.resultadoMensaje == "AU00") {
                var result = JSON.parse(responseStartEnrolled.resultado.respuesta);

                const modifyData = {
                    ...data,
                    isEnrolled: isEnroll,
                    link: result.result.link,
                    image: result.result.qr,
                    instance: result.instance,
                    token: result.Token,
                    id: response.id
                };

                Swal.fire({
                    title: isEnroll ? "Tus patrones faciales están registrados" : "Tus patrones faciales No están registrados",
                    text: isEnroll ? "Serás autenticado mediante reconocimiento facial para validar tu identidad." : "",
                    icon: "info",
                    showCancelButton: !isEnroll,
                    confirmButtonText: "Autorizo",
                    cancelButtonText: "No autorizar",
                    allowOutsideClick: false,
                    reverseButtons: true,
                    customClass: {
                        confirmButton: "btn btn-success",
                        cancelButton: "btn btn-danger",
                    },
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        navigate("/pin/qr-enroll/begin", { state: { data: modifyData } });
                    }
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "Lo sentimos, no podemos verificar tus datos",
                    text: "Nuestro sistema detectó un fallo en el proceso y no pudimos completar el procedimiento. Por favor, vuelve a intentarlo más tarde.",
                    confirmButtonText: "Volver a intentarlo",
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: "btn btn-success",
                        cancelButton: "btn btn-danger",
                    },
                });
            }
        } else {
            Swal.fire({
                title: "Autenticación",
                icon: "warning",
                text: "dataResponse.MESSAGE",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
                customClass: {
                    confirmButton: "btn btn-success",
                    cancelButton: "btn btn-danger",
                },
            });
        }
        setLoading(false);
    };

    const handleGoBack = () => {
        navigate("/pin");
    };

    const ButtonLink = ({ text, onClick }) => (
        <div className="form-group mb-2">
            <Button variant="link" className="col-md-12" onClick={onClick}>
                {text}
            </Button>
        </div>
    );

    useEffect(() => {
        setDisabled(true);
        if (data.password.length == 6) {
            setDisabled(false);
        }
    }, [data.password]);

    return (
        <div className="container">
            <div className="card formulario pin mt-5 mb-5">
                <div className="card-header">
                    <div className="form-row">
                        <div className="titulo">
                            Formulario de Retiro de Pensión Anticipada por Enfermedad Terminal
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="subtitulo mt-3">
                            Modificación datos de contacto
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="form-row">
                        <div className="body-text">
                            <div className="mb-3">Por tu seguridad, para modificar tus datos de contacto deberás:</div>
                            <div className="mb-3">1. Ingresar tu Clave web.</div>
                            <div className="mb-3">2. Validar tu identidad con reconocimiento facial.</div>
                            <div className="mb-3">3. Ingresar el código que recibirás en tus datos de contacto registrados para confirmar el cambio.</div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-12">
                            <Form.Label htmlFor="password" className="col-form-label">
                                <h3><strong>Ingresa tu Clave web</strong></h3>
                            </Form.Label>
                            <div className="input-group">
                                <Form.Control
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    maxLength={6}
                                    placeholder={showPassword ? "Ingresa 6 dígitos" : "*******"}
                                    value={data.password}
                                    onChange={(e) => {
                                        setData((prevData) => ({ ...prevData, password: e.target.value }));
                                    }}
                                />
                                <div className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowPassword((prev) => !prev)}>
                                    <img src={!showPassword ? images.eye_regular : images.eye_slash} width="20" alt="ver" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-4 text-center">
                        <div className="form-group mb-2">
                            <Button
                                variant="success"
                                className="col-md-12"
                                onClick={handleContinuar}
                                disabled={disabled || loading}>
                                {loading ? <Spinner animation="border" variant="light" size="sm" /> : "Continuar"}
                            </Button>
                        </div>
                        {/*<ButtonLink text="¿No la recuerdas? Solicita o recupera tu clave web" />*/}
                        <ButtonLink text="Volver al paso anterior" onClick={handleGoBack} />
                    </div>
                </div>
            </div>
        </div>
    );
}
